import { render, staticRenderFns } from "./myExplain.vue?vue&type=template&id=58c97db0&scoped=true"
import script from "./myExplain.vue?vue&type=script&lang=js"
export * from "./myExplain.vue?vue&type=script&lang=js"
import style0 from "./myExplain.vue?vue&type=style&index=0&id=58c97db0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58c97db0",
  null
  
)

export default component.exports